module.exports = __webpack_public_path__ + "static/service01-936779827923df311f3f7faf11f2de02.jpg";